import { Box, BoxProps, Button, ButtonProps } from "@chakra-ui/react"
import { motion } from "framer-motion"
import * as React from "react"

import { LoginProps } from "../module/account"
import { getRecommendedNetwork } from "../module/network"
import { Bolt } from "./Icons"

const MotionBox = motion<BoxProps>(Box)
interface SwitchNetworkBtnProps extends ButtonProps {
    connectorId: string
    login: LoginProps
}
export function SwitchNetworkBtn(props: SwitchNetworkBtnProps) {
    const { connectorId, login } = props
    const recommendedNetwork = getRecommendedNetwork(connectorId, login)
    return (
        <Button
            flexShrink={0}
            colorScheme="yellow"
            size="sm"
            fontSize="xs"
            onClick={recommendedNetwork.switch}
            {...props}
        >
            <Box boxSize="22px" mr="6px">
                <MotionBox
                    initial={{ rotateY: 0 }}
                    animate={{
                        rotateY: 180,
                        transition: {
                            repeat: Infinity,
                            duration: 0.8,
                            repeatType: "reverse",
                        },
                    }}
                >
                    <Bolt color={"yellow.900"} boxSize={"22px"} />
                </MotionBox>
            </Box>
            <span style={{ marginTop: "2px" }}>Switch Network</span>
        </Button>
    )
}
